import React from 'react'
import style from './Badge.module.css'

interface Props {
  color?: string
  children: React.ReactNode
}
export default function Badge({ children, color = '#32bc42' }: Props) {
  return (
    <span className={style.root} style={{ color, borderColor: color }}>
      {children}
    </span>
  )
}
